import request from "@/utils/request";



export function getMyMsg(params) {
  return request({
    url: '/job/msg/lists',
    method: 'get',
    params:params
  })
}


export function readMsg(msgId) {
  return request({
    url:'/job/msg/read',
    method: 'get',
    params:{ msgId:msgId}
  })
}



// WEBPACK FOOTER //
// ./src/api/msg.js